// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '../styles/variables.scss'
import '../styles/globals.scss'

// Vuetify
import { createVuetify } from 'vuetify'

// https://www.dropbox.com/scl/fo/vcy6i1vxvbgpl5gq7qei3/h?dl=0&preview=0-B.colors.jpg&rlkey=y5lxlapqeuads1sida09lw95y
const colorBlackXgc = '#2D2A24';
const colorWarmGray1u = '#DBD5CD';
const color627cp = '#143A33';
const color553u = '#5A685D';

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    theme: {
      themes: {
        light: {
          colors: {
            background: colorWarmGray1u,
            surface: colorWarmGray1u,
          }
        }
      }
    }
  }
)
